module.exports = __webpack_public_path__ + "static/media/LOGO_CSC_HORINZONTAL.a2fc57da.png";